export default __webpack_public_path__ + "static/logoIPST-cd1da7988adeba02762ca9466046b02d.svg";